import library, { VIDEO_EXTENSIONS } from './sources/library'
import { hasFileSystemAccessAPI } from './videoFileHandle'

const PICKER_TYPES = [{ description: 'Video files', accept: { 'video/*': VIDEO_EXTENSIONS } }]

/** Links a folder of videos to the library; null when cancelled or unsupported. */
export async function pickVideoFolder() {
	if (!('showDirectoryPicker' in window)) return null
	try {
		return await library.linkFolder(await window.showDirectoryPicker({ mode: 'read' }))
	} catch (err) {
		if (err.name === 'AbortError') return null
		throw err
	}
}

export async function pickVideoFile() {
	if (hasFileSystemAccessAPI()) {
		try {
			const [handle] = await window.showOpenFilePicker({ types: PICKER_TYPES })
			const file = await handle.getFile()
			const entry = await library.add({ handle, file })
			return { file, handle, fileName: file.name, id: entry?.id, duration: entry?.duration }
		} catch (err) {
			if (err.name === 'AbortError') return null
			throw err
		}
	}

	// Fallback: temporary <input type="file">
	return new Promise(resolve => {
		const input = document.createElement('input')
		input.type = 'file'
		input.accept = 'video/*'
		input.style.display = 'none'
		document.body.appendChild(input)

		const cleanup = () => document.body.removeChild(input)

		input.addEventListener('change', () => {
			const file = input.files?.[0]
			cleanup()
			if (!file) return resolve(null)
			resolve({ file, handle: null, fileName: file.name })
		})

		input.addEventListener('cancel', () => {
			cleanup()
			resolve(null)
		})

		input.click()
	})
}

/** A library entry from a click: asks for permission when needed. */
export async function openLibraryFile(id) {
	const result = await library.open(id)
	if (!result?.file) return null
	const { entry, file } = result
	return { file, handle: entry.ref, fileName: entry.name, id: entry.id, duration: entry.duration }
}
